// LayoutWithHorizontalTabs.js
import React from "react";
import NavigationTabs from "./HorizontalTabs";
import { Outlet } from "react-router-dom";

function LayoutWithHorizontalTabs() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
        position: "relative",
        paddingTop: "60px", // Adjust based on the height of your tabs
      }}
    >
      <NavigationTabs />
      <main
        style={{
          flexGrow: 1,
          width: "100%",
          overflowX: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default LayoutWithHorizontalTabs;
